import React, { useState, useContext } from 'react';
import { Context } from '../../../Context'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import useStyles from '../../../styles/GlobalStyles';
import ImagePSE from '../../../content/images/PSEImage.png'
import Button from "@material-ui/core/Button"
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { addPaymentProductAsync,  } from '../../../services/paymentService'
import { render } from '@testing-library/react'
import { UseNotification } from '../../../hooks/useNotification'
import { createTransactionAsync } from '../../../services/PSEServive';
import { Loader } from 'react-overlay-loader';
import { v4 as uuidv4 } from 'uuid';
import { v1 as uuidv1 } from 'uuid';
import 'react-overlay-loader/styles.css';
import { UrlsPortal } from '../../utils/utils'
import Grid from '@material-ui/core/Grid';
import { Modal } from '../../../hooks/useModal';
import routesConfig from 'routesConfig';

export const StagePaymentList = ({ paymentArray }) => {
    const classes = useStyles();
    const [disabled, setDisabled] = useState()
    const [loadingPSE, setLoadingPSE] = useState(false)
    const [PSE, setPSE] = React.useState(10);
    const [openConfirm, setOpenConfirm] = useState(false)
    const { isAuth, removeAuth } = useContext(Context);

    function getJsonPSE (productDetail, paymentTicket) {
        const user = JSON.parse(localStorage.getItem('user'))
        var paymentId = getPaymentId()
        return ({
                TicketOfficeID : 2742,
                Amount : productDetail.reduce((total, valor) => total + parseFloat(valor.Amount), 0).toFixed(2),
                GUID: paymentTicket,  
                PaymentId: paymentId,
                PaymentDescription: "Poliza",
                ReferenceNumber2: user.DocumentTypeDes,
                ReferenceNumber3: user.DocumentNumber, 
                DocumentNumber : user.DocumentNumber, 
                DocumentType : user.DocumentTypeDes, 
                Email : user.Email,
                Fields:[
                    {
                        Name: "id_type",
                        Value: user.DocumentTypeDes
                    },
                    {
                        Name: "id_cliente",
                        Value: user.DocumentNumber
                    }
                ],
                ServiceCode: 1561,
                Entity_url: routesConfig.paymentPortalWeb + '?GUID=' + paymentId,
                ProductDetail: productDetail
        })
     };

     function getJsonPSEError (error, productDetail) {
        return ({
                ErrorDescription: error,
                ProductDetail: productDetail
        })
     };
    
    function getPaymentId(){
        const arr = new Array();
        var paymentId = ""
        uuidv1(null, arr, 0);
        for (let index = 0; index < arr.length; index++) {
            if(paymentId.length < 11){
                paymentId = paymentId + arr[index].toString();
            }
        }
        return paymentId
    } 

    async function AddPaymentProductAsync () {
        setOpenConfirm(false)
        const guid = uuidv4();

        try {
            const user = JSON.parse(localStorage.getItem('user'))
            if(user != null){
                var responsePSE = "INTERNAL ERROR"
                setDisabled(!disabled)
                setLoadingPSE(true)
                const jsonPSERequest = getJsonPSE(paymentArray, guid)
                var productDetail = jsonPSERequest.ProductDetail
                var response = await addPaymentProductAsync(paymentArray.reduce((total, valor) => total + parseFloat(valor.Amount), 0), paymentArray, guid, jsonPSERequest, 'REQUEST')
                if(response.status === 200){
                    responsePSE = await createTransactionAsync(jsonPSERequest) 
                    if (responsePSE.data.ReturnCode === 'OK') {
                        var response = await addPaymentProductAsync(paymentArray.reduce((total, valor) => total + parseFloat(valor.Amount), 0), paymentArray, guid, responsePSE.data, 'RESPONSE')
                        render(<UseNotification titleType={1} messageType={1} />)
                        window.location.replace(routesConfig.pseListBank + responsePSE.data.PaymentIdentifier)
                    } else{
                        render(<UseNotification titleType={5} messageType={5} />)
                        responsePSE.data.ProductDetail = productDetail
                        var response = await addPaymentProductAsync(paymentArray.reduce((total, valor) => total + parseFloat(valor.Amount), 0), paymentArray, guid, responsePSE.data, 'RESPONSE')
                    }
                }
                else {
                    render(<UseNotification titleType={5} messageType={5} />)
                }
                setLoadingPSE(false)
                setDisabled(false)
            } else{
                removeAuth(false)
            }
            
        } catch (error) {
            setLoadingPSE(false)
            setDisabled(false)
            render(<UseNotification titleType={4} messageType={4} />)
            var response = await addPaymentProductAsync(paymentArray.reduce((total, valor) => total + parseFloat(valor.Amount), 0), paymentArray, guid, getJsonPSEError(responsePSE, productDetail), 'RESPONSE')
        }
        
    }

    const handlePayment = e => {
        e.preventDefault()
        setOpenConfirm(true)
    }

    const handleClose = () => {
        setOpenConfirm(false);
    }

    const getTotalFormatter = value => value.toString().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    
    return (
        <div className={classes.containerConfirm}>
            <Loader fullPage loading loading={loadingPSE} text={"Cargando..."}/>
            <Typography variant="subtitle1" align="center" style={{fontWeight: 'bold'}}>
                Confirmación del Pago
            </Typography>
            <Paper className={classes.paper}>                
                <List dense={true} className={classes.list}>
                {
                    paymentArray.map((paymentItem) => {
                    return (
                        <ListItem key={paymentItem.ProductReferenceNumber}  className={classes.listItem}>
                            <ListItemText primary={paymentItem.ReferenceDesc} secondary={paymentItem.ProductReferenceNumber} />
                            <ListItemSecondaryAction className={classes.listItem}>
                            <Typography align="right">
                                {paymentItem.AmountFormatter}
                            </Typography>
                            </ListItemSecondaryAction>
                        </ListItem> 
                    )
                    })
                }
                </List>
            </Paper>
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid item xs={12}>
                    <Typography align="left">
                        Productos seleccionados ({paymentArray.length})
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography align="left" variant="h6" style={{fontWeight:'bold'}}> 
                        Total a pagar: {getTotalFormatter(paymentArray.reduce((total, valor) => total + parseFloat(valor.Amount), 0).toFixed(2))}
                    </Typography> 
                </Grid>
            </Grid>
            <Grid container alignItems="flex-end" className={classes.form}>
                <InputLabel id="label">Método de pago</InputLabel>
                <Select 
                    labelId="label" 
                    id="select" 
                    className={classes.form}
                    value={PSE}>
                    <MenuItem value="10" className={classes.form}>
                        <ListItemIcon>
                            <img src={ImagePSE}  style={{width: '35px', marginRight : '10px'}}/>
                            <ListItemText style = {{alignItems : 'center'}} primary="Débito Bancario PSE" />
                        </ListItemIcon>
                    </MenuItem>
                </Select>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="secondary"
                    className={classes.submit}
                    onClick={handlePayment.bind(this)}
                    disabled={paymentArray === undefined || paymentArray.length == 0}
                >
                    PROCEDER A PAGAR
                </Button>
                <Modal  maxWidth="xs"
                        isOpen={openConfirm}
                        actionsFooter
                        onClose={handleClose}
                        handleCancel={handleClose}
                        handleConfirm={AddPaymentProductAsync}
                        titleModal = "Confirmación de pago">
                    <Typography variant="h6" align="left">
                        Está seguro de continuar con el pago ?
                    </Typography>        
                </Modal>
            </Grid>
        </div> 
    )   
}